var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCapitalOneSbb = function SvgCapitalOneSbb(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_622)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6417 21.0953C18.6417 20.7501 18.3618 20.4703 18.0167 20.4703H3.01666C2.67148 20.4703 2.39166 20.7501 2.39166 21.0953C2.39166 21.4405 2.67148 21.7203 3.01666 21.7203H18.0167C18.3618 21.7203 18.6417 21.4405 18.6417 21.0953Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.02491 8.85606C6.83755 8.56616 6.45064 8.48304 6.16074 8.6704L2.88124 10.79C2.72596 10.8922 2.59845 11.0314 2.5101 11.195C2.42176 11.3586 2.37534 11.5416 2.375 11.7275L2.375 11.7286L2.375 12.4703C2.375 12.7687 2.49352 13.0548 2.7045 13.2658C2.91548 13.4768 3.20163 13.5953 3.5 13.5953H7.5C7.84518 13.5953 8.125 13.3155 8.125 12.9703C8.125 12.6251 7.84518 12.3453 7.5 12.3453H3.625V11.7976L6.83926 9.72022C7.12916 9.53286 7.21228 9.14596 7.02491 8.85606Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.89166 12.3453C4.54648 12.3453 4.26666 12.6251 4.26666 12.9703V21.0953C4.26666 21.4405 4.54648 21.7203 4.89166 21.7203C5.23684 21.7203 5.51666 21.4405 5.51666 21.0953V12.9703C5.51666 12.6251 5.23684 12.3453 4.89166 12.3453Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.625 14.375C8.97018 14.375 9.25 14.6548 9.25 15L9.25 21C9.25 21.3452 8.97018 21.625 8.625 21.625C8.27982 21.625 8 21.3452 8 21L8 15C8 14.6548 8.27982 14.375 8.625 14.375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3917 16.5703C12.0465 16.5703 11.7667 16.8501 11.7667 17.1953V21.0953C11.7667 21.4405 12.0465 21.7203 12.3917 21.7203C12.7368 21.7203 13.0167 21.4405 13.0167 21.0953V17.1953C13.0167 16.8501 12.7368 16.5703 12.3917 16.5703Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.5703C16.3452 16.5703 16.625 16.8501 16.625 17.1953L16.625 21C16.625 21.3452 16.3452 21.625 16 21.625C15.6548 21.625 15.375 21.3452 15.375 21L15.375 17.1953C15.375 16.8501 15.6548 16.5703 16 16.5703Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 16.1953C18.866 16.1953 22 13.0613 22 9.19531C22 5.32932 18.866 2.19531 15 2.19531C11.9476 2.19531 9.35151 4.14903 8.39402 6.87418C13.0694 6.23907 17.9719 5.98674 19.0791 7.26168C19.8604 8.16173 18.2077 9.79105 15.7461 11.4957C15.6282 11.5774 12.1492 13.7554 11.9521 13.8727C11.9428 13.8508 11.9331 13.8342 11.9232 13.8213C11.9326 13.8386 11.9422 13.8558 11.9521 13.8727C11.9452 13.8756 11.9385 13.8798 11.9317 13.884L11.93 13.885C11.4848 14.1405 11.0405 14.394 10.6026 14.642C11.8044 15.6135 13.3343 16.1953 15 16.1953ZM10.3579 14.4348C10.8545 14.0974 11.3255 13.7665 11.7648 13.442C11.7648 13.441 11.7654 13.4406 11.7662 13.4401C11.7667 13.4398 11.7673 13.4395 11.7678 13.4389C11.7679 13.4391 11.768 13.4394 11.768 13.4397C11.8751 13.3606 11.9923 13.2766 12.1177 13.1867C12.9312 12.6034 14.0892 11.7731 15.0562 10.4619C15.6871 9.60634 15.8169 8.88335 15.2729 8.32022C14.2946 7.30747 11.3547 7.16055 8.24402 7.35648C8.08491 7.94245 8 8.55897 8 9.19531C8 11.2803 8.91158 13.1524 10.3579 14.4348Z",
    fill: "#D03027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCapitalOneSbb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "capital-one-sbb.2e9a183088fb97bb70fce907ba55a413.svg";